import React, { useState } from 'react';
import { Icon } from '../../pages/DesignSystem';
import './OfflineMessage.css';

interface OfflineMessageProps {
  hasCache: boolean;
}

const OfflineMessage: React.FC<OfflineMessageProps> = ({ hasCache }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  // With cache, show a discreet badge
  if (hasCache) {
    return (
      <div className="offline-badge">
        <Icon name="WifiOff" size={14} className="offline-badge__icon" />
        <span className="offline-badge__text">Offline - Showing cached events only</span>
        <button
          className="offline-badge__dismiss"
          onClick={() => setIsDismissed(true)}
          aria-label="Dismiss"
        >
          <Icon name="X" size={12} />
        </button>
      </div>
    );
  }

  // Without cache, initial connection is required - more visible message but still compact
  return (
    <div className="offline-badge offline-badge--no-cache">
      <Icon name="WifiOff" size={14} className="offline-badge__icon" />
      <span className="offline-badge__text">Connection required to load events</span>
      <button
        onClick={() => window.location.reload()}
        className="offline-badge__retry"
      >
        Retry
      </button>
      <button
        className="offline-badge__dismiss"
        onClick={() => setIsDismissed(true)}
        aria-label="Dismiss"
      >
        <Icon name="X" size={12} />
      </button>
    </div>
  );
};

export default OfflineMessage; 